import { RouteObject } from 'react-router';

import { CommunitiesContainer } from 'features/admin/features/communities/containers/CommunitiesContainer';
import { PaymentsContainer } from 'features/admin/features/payments/containers/PaymentsContainer';
import { FeedbackContainer } from 'features/admin/features/feedback/containers/FeedbackContainer';

import { FeedbackAnswerContainer } from './features/feedback/containers/FeedbackAnswerContainer';
import { AdminPage } from './pages/AdminPage';
import { UsersContainer } from './features/users/containers/UsersContainer';
import { CommissionModal } from './features/users/components/CommissionModal';
import shopDetails from './features/shop-details';
import { extraRoutes } from './features/shop-details/routes';

const routes: RouteObject[] = [
    {
        path: 'admin',
        element: <AdminPage />,
        children: [
            {
                path: 'users',
                element: <UsersContainer />,
                children: [
                    {
                        path: ':id/:commission',
                        element: <CommissionModal />,
                    },
                ],
            },
            {
                path: 'communities',
                element: <CommunitiesContainer />,
            },
            {
                path: 'payments',
                element: <PaymentsContainer />,
            },
            {
                path: 'feedback',
                children: [
                    { index: true, element: <FeedbackContainer /> },
                    { path: ':id', element: <FeedbackAnswerContainer /> },
                ],
            },
            ...shopDetails.routes,
        ],
    },
    ...extraRoutes,
];
export default routes;
